import React, { FC, Fragment } from 'react'
import styles from '../styles/index.module.css'
import { KebabMenuIcon } from '@/components/icons/KebabMenuIcon'
import { Menu, Transition } from '@headlessui/react'
import { twMerge } from 'tailwind-merge'
import SvgSpinnerBlue from '@/components/icons/spinner-blue'

interface DropDownOption {
  name: string
  title: React.ReactNode
  description?: string
  handleClick?: () => void
  icon?: React.ReactNode
  buttonClassName?: string
}

interface Props {
  dropDownOptions: DropDownOption[]
  isLoading?: boolean
}

export const CourseSettingsBtn: FC<Props> = ({
  dropDownOptions,
  isLoading,
}) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      {({ open }) => (
        <>
          <div>
            <Menu.Button
              className={twMerge(
                'flex items-center justify-center text-base font-medium rounded-lg p-1.5 focus:outline-none bg-none',
                open
                  ? `bg-cblue-50 ${styles.courseSettingsBtnOpened}`
                  : 'relative',
                styles.courseSettingsBtn,
              )}
            >
              {/* Open Button */}

              {isLoading ? (
                <SvgSpinnerBlue withyMargin={false} classess="w-5 h-5" />
              ) : (
                <KebabMenuIcon />
              )}
            </Menu.Button>
          </div>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items
              className={`absolute right-0 z-50 border border-v8-line origin-top-right bg-white shadow-lg top-[35px] rounded-lg focus:outline-none`}
            >
              <div className="px-1 py-1 space-y-1">
                {/* Dropdown Options */}
                {dropDownOptions.map((option, index) => {
                  return (
                    <Menu.Item key={`${index}-${option.name}`}>
                      {({ active }) => {
                        const className: string = option.buttonClassName
                          ? option.buttonClassName
                          : twMerge(
                              'text-sm hover:bg-v8-blue/5 rounded-md flex px-2 py-0.5 w-[80px] flex gap-1.5 justify-start items-center',
                              active
                                ? 'bg-v8-paper text-v8-ink'
                                : 'text-v8-ink',
                            )

                        return (
                          <button
                            onClick={() =>
                              option.handleClick && option.handleClick()
                            }
                            className={className}
                          >
                            {!!option.icon && <>{option.icon}</>}
                            {option.title}
                          </button>
                        )
                      }}
                    </Menu.Item>
                  )
                })}
              </div>
            </Menu.Items>
          </Transition>
        </>
      )}
    </Menu>
  )
}
